import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { AppBar, Box, Button, Divider } from '@mui/material';

/**
 * チャットメッセージのヘッダー部分を表現する
 * @param props
 * @returns
 */
const ChatHeaderRemote = (props: {
  onChangeRemoteMode: () => void;
  onChangeRemoteModeDual: () => void;
}) => {
  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: 0,
        borderRadius: 0,
        visibility: 'visible',
      }}
      color="default"
    >
      <Box display={'grid'} gridTemplateColumns="1fr auto" alignItems="center">
        <Box
          display="grid"
          gridTemplateColumns="auto 1fr"
          gridTemplateRows="auto auto"
        >
          <Button
            color={'inherit'}
            sx={{
              width: '36px',
              height: '36px',
              minWidth: 0,
              m: 1,
              gridRow: '1/3',
            }}
            onClick={() => {
              props.onChangeRemoteMode();
              props.onChangeRemoteModeDual();
            }}
          >
            <LockOutlinedIcon fontSize="medium" />
          </Button>
        </Box>
      </Box>
      <Divider />
    </AppBar>
  );
};
export default ChatHeaderRemote;
